import { string, shape, number } from 'prop-types';

export default shape({
    id: number.isRequired,
    name: string.isRequired,
    url: string.isRequired,
});
